import { lazy } from "react"

export const FuelQuoteById = lazy(() => import("./FuelQuoteById"))